
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getMovieList, getAlltheData } from '../../actions/movielist-actions'
import { appHeightChanged } from '../../actions/app-actions'
import { useHistory } from 'react-router-dom'
import EbilletProgram from './components/EbilletProgram'
import moment from 'moment'


class EbilletHome extends React.Component {
    constructor() {
        super();
       

    }
    componentDidMount() {
        const { actions, movies, organizerIds, iframeId } = this.props
      
        if (window.parent != window) actions.appHeightChanged(iframeId, false, false, true);
       
        actions.getAlltheData()
        actions.getMovieList(3)
    }

    componentWillUnmount() {
        const { actions, iframeId } = this.props;
        if (window.parent != window) actions.appHeightChanged(iframeId, false, true, false);
        else sessionStorage.setItem("scroll-position", window.scrollY);
    }

    
    render() {
        const { allEvents, allLocations, allMovieBases, allMovies, allOrganizers, ageCensor, allEventsTypes, actions, iframeId, backTo } = this.props;
        let filteredEvents = allEvents && allEvents.filter(ev => { return ev.webEnable._show === 1 })
       
        const params = new URLSearchParams(window.location.search);
        const site_type = params.get("sitetype");
        const ifr = params.get("iframeid")
        console.log(ifr)
        return (
            <div >


                {allEvents && allLocations && allMovies && allOrganizers ?
                    <EbilletProgram
                        allMovies={allMovies}
                        allEvents={filteredEvents}
                        allOrganizers={allOrganizers}
                        locations={allLocations}
                        ageCensor={ageCensor}
                        allEventsTypes={allEventsTypes}
                        allMovieBases={allMovieBases}
                        appHeightChanged={actions.appHeightChanged}
                        iframeId={iframeId}
                        backTo={backTo}
                        site_type={site_type }
                    />
                    : <div className="spinner"></div>
                }
            </div>
         )
    }
}

const mapStateToProps = (state, ownProps) => {
    console.log(state)
    const config = state.organizer.configuration;
    const listConfig = config.movielists;
    const movies = listConfig.date.base ? extractMoviesAsBases(state.movielist.movies) : state.movielist.movies;
    function extractMoviesAsBases(movies) {
        const moviesBases = state.movielist.movieBases;
        const moviesAsBase = [];
        _.each(movies, (movie) => {
            if (movie.baseId) {
                const baseMovie = _.find(moviesBases, (base) => { return base.id == movie.baseId; });
                const alreadyInList = _.some(moviesAsBase, ['baseId', movie.baseId]);
                if (baseMovie && !alreadyInList) moviesAsBase.push({ ...movie, name: baseMovie.name, posters: baseMovie.posters });
            } else moviesAsBase.push(movie);
        });
        return moviesAsBase;
    }

    return {
        movies,
        allMovies:    state.movielist.allMovies,
        allEvents:    state.movielist.allEvents,
        allLocations: state.movielist.allLocations,
        allMovieBases:state.movielist.allMovieBases,
        allOrganizers:state.movielist.allOrganizers,
        ageCensor:    state.movielist.ageCensor,
        allEventsTypes: state.movielist.allEventsTypes,
        iframeId: state.app.iframeId,
        backTo: state.movielist.backTo,
       

      
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { getAlltheData, appHeightChanged, getMovieList }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EbilletHome)